import React, { useEffect, useState } from 'react';
function getInitialSeconds(): number {
  // Persist a 24h countdown per visitor so it keeps ticking across reloads
  const KEY = 'futsal360_countdown_end';
  const now = Date.now();
  let end = Number(localStorage.getItem(KEY));
  if (!end || end < now) {
    end = now + 24 * 60 * 60 * 1000 - 23 * 1000; // ~23:59:37 to match copy
    localStorage.setItem(KEY, String(end));
  }
  return Math.max(0, Math.floor((end - now) / 1000));
}
function pad(n: number): string {
  return String(n).padStart(2, '0');
}
export function CountdownTimer() {
  const [secondsLeft, setSecondsLeft] = useState<number>(() => {
    try {
      return getInitialSeconds();
    } catch {
      return 23 * 3600 + 59 * 60 + 37;
    }
  });
  useEffect(() => {
    const id = setInterval(() => {
      setSecondsLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(id);
  }, []);
  const hrs = Math.floor(secondsLeft / 3600);
  const mins = Math.floor(secondsLeft % 3600 / 60);
  const secs = secondsLeft % 60;
  return <div className="text-3xl font-mono font-bold tracking-widest mb-2" role="timer" aria-live="off" aria-label={`${hrs} horas, ${mins} minutos y ${secs} segundos restantes`} data-id="element-10">
      {pad(hrs)} HS : {pad(mins)} MIN : {pad(secs)} SEG
    </div>;
}